import React from 'react'


import './styles/winmodal.css'

const WinModal = ({ message, botonMessage, buttonClick, image }) => {
  return (
    <div className='modal'>
        <div className='win-screen'>
          <div className='win-window'>
              <p className='win-message'>{ message }</p>
              { image ? <img src={ image } alt="mensaje" className="win-image" /> : '' }
              <div className='win-button-container'>
                <button className='win-button' onClick={ buttonClick }>{ botonMessage }</button>
              </div>
          </div>
        </div>
    </div>
    
  )
}

export default WinModal